import{jsx as o}from"react/jsx-runtime";import{FontIcon as t}from"../../../FontIcon/FontIcon.js";const n=({isSortedDescending:n,isSorted:r,className:e})=>r?o(t,{iconName:n?"SortDown":"SortUp",className:e}):null;export{n as GridDetailsListSort};
//# sourceMappingURL=GridDetailsListSort.js.map
